// import Navbar from "./components/layout/navbar";
// // import * as ReactDOM from "react-dom/client";
// import { RouterProvider } from "react-router-dom";
import RouteController from "./navigation/controller.js";

function App() {
  return <RouteController />;
}

export default App;
